import * as angular from 'angular';
import { OperationService } from '../../operation.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { StateParams, StateService } from '@uirouter/core';
import { IOperationStatisticDetailedModel } from '../../models';

class OperationComponent implements ng.IComponentController {
    static $inject = ['operationService', 'notificationService', '$stateParams', '$state'];

    operation: IOperationStatisticDetailedModel;
    error: any;

    private readonly opeartionId: string;

    constructor(
        private readonly operationService: OperationService,
        private readonly notificationService: NotificationService,
        $stateParams: StateParams,
        private readonly $state: StateService
    ) {
        this.opeartionId = $stateParams.id;
    }

    $onInit() {
        this.loadOperation();
    }

    goToProductImport() {
        this.$state.go('app.operations');
    }

    private loadOperation() {
        this.notificationService.showWaitingMessage();
        this.error = undefined;

        this.operationService.getOperation(this.opeartionId)
            .then(response => this.operation = response)
            .catch(error => {
                this.notificationService.showErrorMessage(error);
                this.error = error;
            })
            .finally(() => this.notificationService.clearAll());
    }
}

angular
    .module('naut')
    .component('operationComponent', {
        controller: OperationComponent,
        template: require('./operationComponent.html')
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/inventory/components/operation/operationComponent.ts